(function () {
    'use strict';

    angular
        .module('app')
        .directive('selectioncommandexpediteapprove', selectioncommand_expediteapprove);

    selectioncommand_expediteapprove.$inject = ['$window'];

    function selectioncommand_expediteapprove($window) {
        // Usage:
        //     <toolbar></toolbar>
        // Creates:
        //
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                expediateApproveDialogShown: '=?',
                xuid: '@'
            },
            controller: 'expediteApprove',
            templateUrl: 'app/selectioncommand/selectioncommand_expediteapprove.html'
        };
        return directive;

        function link(scope, element, attrs) {

            

        }
    }
})();